import { motion } from "framer-motion";

export default function AuthShell({ testid, logoTestid, eyebrow, title, sub, children, footer }) {
  return (
    <div data-testid={testid} className="grid lg:grid-cols-2 min-h-screen">
      <div className="relative hidden lg:block overflow-hidden">
        <img src="/assets/about-friends.webp" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/15" />
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="absolute bottom-0 left-0 right-0 p-12 xl:p-16"
        >
          <p className="text-xs font-ui tracking-[0.35em] uppercase text-white/70">Nassau · Bahamas</p>
          <p className="mt-5 font-display text-4xl xl:text-5xl text-white leading-tight">
            Your next road trip <span className="italic text-[#ff5a66]">begins</span> with us.
          </p>
          <div className="mt-8 flex items-center gap-5 text-white/85 text-sm font-ui">
            <span>Premium fleet</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#C71E2E]" />
            <span>Free hotel & villa delivery</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#C71E2E]" />
            <span>Loyalty rewards</span>
          </div>
        </motion.div>
      </div>
      <div className="flex items-center justify-center px-6 sm:px-10 pt-28 pb-16 lg:pt-36 lg:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-lg"
        >
          <div className="lg:hidden relative rounded-3xl overflow-hidden mb-10 h-44">
            <img src="/assets/about-friends.webp" alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/10" />
            <p className="absolute bottom-4 left-5 font-display text-2xl text-white">Nassau · Bahamas</p>
          </div>
          <img src="/logo.png" alt="Easy Drive Car Rental" data-testid={logoTestid} className="h-24 w-auto object-contain" />
          <p className="mt-8 text-sm font-ui tracking-[0.3em] uppercase text-primary flex items-center gap-2">{eyebrow}</p>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tight">{title}</h1>
          {sub && <p className="mt-4 text-base sm:text-lg text-muted-foreground font-ui">{sub}</p>}
          {children}
          {footer}
        </motion.div>
      </div>
    </div>
  );
}
